import { outboundExchangeKey, parcelTypes } from '@/parcels/constants'

export const parcelTypeOptions = [
  { value: parcelTypes.outbound, label: 'Envío de pedido' },
  { value: outboundExchangeKey, label: 'Envío de cambio' },
  { value: parcelTypes.tracking, label: 'Envío externo' },
]
